import React from 'react';

import { MediaLibrarySingleAssetProvider } from 'src/application/ContentZone/components/Widgets/MediaLibraryAssetProvider/MediaLibrarySingleAssetProvider';
import { useIntlReexport } from 'src/application/hooks/useIntlReexport';
import { tooltipMessages } from 'src/translates/tooltipMessages';

import { useContentRequirementsContext } from '../../../../features/RestrictNavigation/ContentRequirementsProvider';
import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { ExistingStudentWidgetProps } from '../Widget';
import { AudioWidget as AudioWidgetModel, WidgetType } from '@ael/core-api';
import { WidgetAudioPlayer } from '@ael/shared-components-library';

type AudioWidgetData = {
  assetUrl: string;
};
export const AudioWidget: React.FC<ExistingStudentWidgetProps> = ({ widget }) => {
  const { value: audioWidget } = widget as AudioWidgetModel;
  const { submitWidget } = useContentRequirementsContext();
  const fulfillCurrentWidget = () => submitWidget(widget, true);
  const { formatMessage } = useIntlReexport();

  return (
    <StudentWidgetWrapper>
      <MediaLibrarySingleAssetProvider<AudioWidgetData>
        assetId={audioWidget.data.assetId}
        widgetId={widget._id}
        widgetType={WidgetType.audio}
      >
        {(data) => {
          if (data && data.assetUrl) {
            return (
              <WidgetAudioPlayer
                src={data.assetUrl}
                requirements={
                  audioWidget.properties.isRequired
                    ? { isMandatory: true, onEnded: fulfillCurrentWidget }
                    : { isMandatory: false }
                }
                tooltipTextPlay={formatMessage(tooltipMessages.play_audio)}
                tooltipTextPause={formatMessage(tooltipMessages.pause_audio)}
                title={audioWidget.properties.title}
              />
            );
          }
          return null;
        }}
      </MediaLibrarySingleAssetProvider>
    </StudentWidgetWrapper>
  );
};
